'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAway = undefined;

var _isAgentState = require('./isAgentState');

var _AgentStates = require('../../constants/AgentStates');

var isAway = exports.isAway = (0, _isAgentState.isAgentState)(_AgentStates.AWAY);